export default __webpack_public_path__ + "static/media/39.0b833c49.png";